import { ApiInvoices, ApiListTicketless, ApiOrder, ApiOrders, ApiReceipts } from './api-order.models';

import { Invoices, ListTicketless, Order, Orders, Receipts } from '@api/order/order.models';

// Clase de utilidad para transformar los objetos que devuelve el api de inditex en los objetos que usaremos en el cms, widgets y render

// biome-ignore lint/complexity/noStaticOnlyClass: <explanation>
export class OrderTransformer {
    public static OrderFromApi(apiOrder: ApiOrder): Order {
        return {
            ...apiOrder,
        } as Order;
    }

    public static OrdersFromApi(apiOrders: ApiOrders): Orders {
        return {
            ...apiOrders,
            orders: apiOrders.orders.map((order) => OrderTransformer.OrderFromApi(order)),
        } as Orders;
    }

    public static InvoicesFromApi(apiInvoices: ApiInvoices): Invoices {
        return apiInvoices as Invoices;
    }

    public static ListTicketlessFromApi(listTicketless: ApiListTicketless): ListTicketless {
        return listTicketless as ListTicketless;
    }

    public static ReceiptsFromApi(apiReceipts: ApiReceipts): Receipts {
        return apiReceipts as Receipts;
    }
}
